import { render, staticRenderFns } from "./EliminarPSP.vue?vue&type=template&id=008017db&"
import script from "./EliminarPSP.vue?vue&type=script&lang=js&"
export * from "./EliminarPSP.vue?vue&type=script&lang=js&"
import style0 from "./EliminarPSP.vue?vue&type=style&index=0&id=008017db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports